var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"pa-0":""}},[_c('v-row',[_c('div',{staticClass:"page__title"},[_c('div',[_c('h1',[_vm._v("Historia aktywności")])])])]),_c('list-wrapper',{attrs:{"total":_vm.count,"per-page":16}},[_c('history',{attrs:{"title":"Historia","show-more":false}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }